import React, { useState } from 'react';
import "./ProfileDropDown.css";
import { IChannelItem } from "../~store/models/ChannelItem";
import {
  IOperatorStatusViewModel,
  OperatorStatusType,
} from "../~store/state/ChatItemsState";
import { getDateTimeFromNumber } from "src/app/shared/helpers/date-helper/DateFormats";
import { FIRST_PAUSE_CATEGORY_ID } from "../~store/actions/ChatConstants";
import { useTranslation } from "react-i18next";
import i18n from "src/app/shared/localization/i18n";
import { Button, Input} from "reactstrap";
import { FILTER_STATUS} from "./constants";
interface IProfileDropdownProps {
  onLogout: CallableFunction;
  operatorChannels: IChannelItem[];
  operatorsStatusList: IOperatorStatusViewModel[];
  pauseCategories: string[];
}

const ProfileDropDown = (props: IProfileDropdownProps) => {
  const { t } = useTranslation();
  const [filterStatus, setFilterStatus] = useState<typeof FILTER_STATUS[keyof typeof FILTER_STATUS]>(FILTER_STATUS.Online);

  const _mapOperatorStatusList = (
    operatorsStatusList: IOperatorStatusViewModel[]
  ) => {
    if (operatorsStatusList.length > 0)
      return (
        <table className="operator_list_container">
          <thead style={{ borderBottom: "1px solid" }}>
            <td>{t("common.name")}</td>
            <td>{t("common.status")}</td>
            <td>{t("common.setOn")}</td>
          </thead>
          {operatorsStatusList.map((item) => {
            return (
              <tr>
                <td>{item.name}</td>
                <td>
                {
                 item.status >= FIRST_PAUSE_CATEGORY_ID
                 ? props.pauseCategories[ item.status - FIRST_PAUSE_CATEGORY_ID]
                 : i18n.t(`common.${OperatorStatusType[item.status].toLowerCase()}`)
                }
                </td>
                <td>{getDateTimeFromNumber(item.setOn)}</td>
              </tr>
            );
          })}
        </table>
      );
  };

  const userInStorage = sessionStorage.getItem("user");
  const userRole =
    userInStorage === null ? "" : JSON.parse(userInStorage.toString()).role;
  const login =
    userInStorage === null ? "" : JSON.parse(userInStorage.toString()).login;
  const isSupervisor = userRole === "Supervisor" ? true : false;
  const filteredOperators = props.operatorsStatusList.filter((operator) => {
    switch (filterStatus) {
        case FILTER_STATUS.Online:
            return operator.status !== OperatorStatusType.Offline;
        case FILTER_STATUS.Offline:
            return operator.status === OperatorStatusType.Offline;
        case FILTER_STATUS.All:
        default:
            return true;
        }
  });

  return (
    <div className="profile-container">
      <div className="profile-container__profile-block">
        <div>
          {t("chatsPanel.youAreLoggedInAs")}
          <span style={{ fontWeight: "bold" }}>{login}</span>
        </div>
        <div>
          {t("chatsPanel.toChangeTheUserPress")}
          <Button onClick={() => props.onLogout()}>{t("common.logout")}</Button>
        </div>
      </div>
      <div className="profile-container__filter-block">
        <div style={{ fontWeight: "bold" }}> {t('common.operators')} </div>
            <Input id="operator-filter" type="select" value={filterStatus} className="browser-default"
                onChange={(e) => setFilterStatus(e.target.value as typeof filterStatus)}>
                <option value={FILTER_STATUS.Online}>{t('common.online')}</option>
                <option value={FILTER_STATUS.Offline}>{t('common.offline')}</option>
                <option value={FILTER_STATUS.All}>{t('chats.all')}</option>
            </Input>
      </div>
      {_mapOperatorStatusList(filteredOperators)}
      <div className="profile-container__profile-block">
        <div>{t("chatsPanel.haveBeenAssignedChannels")}</div>
          {props.operatorChannels.map((item, index) => (
           <div key={index} className="profile-container__channel-row">
            <span className="profile-container__profile-channel-type-container">
              <img
                className={
                  "channel-type-img profile-container__profile-channel-type-" +
                  item.type
                }
              ></img>
            </span>
                  <span className="profile-container__profile-channel-name">
                      {item.name}
                  </span>
            <span className="profile-container__profile-channel-priority">
              {isSupervisor
                ? ""
                : "Tier " + item.operatorPriorityType.toString()}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileDropDown;
